var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSplitCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "m10.957 4.856-.424 1.51 1.51.423.424-1.51z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "m12.836 4.344-1.61-.451.108-.383a1.563 1.563 0 0 1 1.933-1.087l9.062 2.54a1.563 1.563 0 0 1 1.087 1.933L20.03 18.98a1.563 1.563 0 0 1-1.933 1.087l-3.726-1.048.423-1.507 2.97.833a.787.787 0 0 0 .968-.544l2.962-10.572a.787.787 0 0 0-.543-.967l-3.776-1.058-.288 1.028A2.56 2.56 0 0 0 15.6 5.118l-1.352-.379.107-.382-.755-.212a.79.79 0 0 0-.763.199"
})), /*#__PURE__*/React.createElement("mask", {
  id: "SplitCard_svg__a",
  width: 17,
  height: 19,
  x: 0,
  y: 3,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.334 4.629.948 16.71a1.556 1.556 0 0 0 1.089 1.926l9.06 2.547a1.563 1.563 0 0 0 1.933-1.087l3.386-12.082A1.563 1.563 0 0 0 15.33 6.08l-9.062-2.54A1.563 1.563 0 0 0 4.334 4.63m10.36 3.718-2.963 10.572a.787.787 0 0 1-.966.543l-3.776-1.058 3.386-12.082 3.776 1.058c.415.116.66.551.543.967m-10.726 9.21L7.354 5.476 6.6 5.264a.787.787 0 0 0-.967.543L2.67 16.38a.786.786 0 0 0 .543.967z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#SplitCard_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M-2.92 18.885 2.16.76 20.282 5.84l-5.079 18.124z"
}))));
export { SvgSplitCard as ReactComponent };
export default __webpack_public_path__ + "SplitCard.dc143a4a.svg";